import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ObjectTypes } from '@fi-shared/types';
import { FiDeleteConnectedOboardingElementDialogService } from './fi-delete-connected-oboarding-element-dialog.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { INameIdObj } from '@fi-app/shared/fi-shared-interfaces';

export interface IFiDeleteConnectedOboardingElementDialogData {
    ObjectType: ObjectTypes;
    ConnectedOnboardings: INameIdObj[];
    HasResponses: boolean;
    isNewElement: boolean;
}

@Component({
    selector: 'fi-delete-connected-oboarding-element-dialog',
    templateUrl: './fi-delete-connected-oboarding-element-dialog.component.html',
    styleUrls: ['./fi-delete-connected-oboarding-element-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-delete-connected-oboarding-element-dialog' },
    standalone: false,
})
export class FiDeleteConnectedOboardingElementDialogComponent extends FiDialogsContentBase<
    IFiDeleteConnectedOboardingElementDialogData,
    void
> {
    private fiDeleteConnectedOboardingElementDialogService = inject(FiDeleteConnectedOboardingElementDialogService);
    private appTextService = inject(AppTextService);

    protected messageText = this.fiDeleteConnectedOboardingElementDialogService.getMessageText({
        objectType: this.data.ObjectType,
        connectedOnboardingsCount: this.data.ConnectedOnboardings.length,
        hasResponses: this.data.HasResponses,
    });
    protected simpleConfirmDeleteMessageText =
        this.fiDeleteConnectedOboardingElementDialogService.getSimpleConfirmDeleteMessageText(this.data.ObjectType);

    protected readonly confirmText = this.appTextService.get('common.delete').toUpperCase();
    protected userConfirmMessage = '';

    public isYesButtonDisabled(): boolean {
        return this.data.HasResponses ? this.userConfirmMessage !== this.confirmText : false;
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
